(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fgr4-v46-match-cross-sell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fgr4-match-cross-sell')) {
  customElements.define('fgr4-match-cross-sell', class extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-f46-match-variants]');
      if (!data) return;

      try {
        this.variants = JSON.parse(data.textContent || '[]');
      } catch {
        this.variants = [];
      }

      this.optionInputs = Array.from(this.querySelectorAll('[data-f46-option]'));
      this.variantInput = this.querySelector('input[ref="variantId"]');
      this.priceNode = this.querySelector('[data-f46-match-price]');
      this.button = this.querySelector('button[ref="addToCartButton"]');
      this.addContainer = this.querySelector('add-to-cart-component');
      this.currency = this.dataset.currency || 'GBP';

      this.onChange = () => this.update();
      this.optionInputs.forEach((input) => {
        if (input instanceof HTMLSelectElement) input.addEventListener('change', this.onChange);
      });

      this.update();
    }

    disconnectedCallback() {
      this.optionInputs?.forEach((input) => {
        if (input instanceof HTMLSelectElement) input.removeEventListener('change', this.onChange);
      });
    }

    update() {
      const selected = [];
      this.optionInputs.forEach((input) => {
        const index = Number(input.dataset.optionIndex);
        selected[index] = input.value;
      });

      const variant = this.variants.find((item) =>
        item.options.every((value, index) => selected[index] === value)
      );

      if (!variant) {
        if (this.button) this.button.disabled = true;
        return;
      }

      if (this.variantInput) this.variantInput.value = String(variant.id);
      if (this.priceNode) {
        this.priceNode.textContent = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(Number(variant.price) / 100);
      }
      if (this.button) this.button.disabled = !variant.available;
      if (this.addContainer && variant.image) this.addContainer.dataset.productVariantMedia = variant.image;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
